/* eslint no-underscore-dangle: 0 */

import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import configureStore from './store/configureStore';

const initialState = window.__INITIAL_STATE__;

export const store = configureStore(initialState, browserHistory);

export const history = syncHistoryWithStore(browserHistory, store);



// WEBPACK FOOTER //
// ./src/store.js